import type { Unit } from "../constants";
import { UNITS } from "../constants";

interface ParsedDimension {
  numeric: string;
  unit: Unit;
}

const AUTO_DIMENSION: ParsedDimension = {
  numeric: "",
  unit: "auto",
};

const NONE_DIMENSION: ParsedDimension = {
  numeric: "",
  unit: "none",
};

// eslint-disable-next-line sonarjs/slow-regex -- Disabled for plugin version update. Fix when possible
const DIMENSION_REGEX = /^(\d*\.?\d*)(px|%|em|rem|vw|vh|auto|none)$/i;

const isValidUnit = (value: string): value is Unit =>
  UNITS.includes(value as Unit);

const getDefaultUnit = (): Unit => "px";

export const parseDimension = (value: string | undefined): ParsedDimension => {
  if (value === "none") return NONE_DIMENSION;
  if (!value || value === "auto") return AUTO_DIMENSION;

  const match = DIMENSION_REGEX.exec(value);
  if (!match) return { numeric: "0", unit: getDefaultUnit() };

  const [, numericPart, unitPart] = match;

  return {
    numeric: numericPart || "0",
    unit: isValidUnit(unitPart) ? unitPart : getDefaultUnit(),
  };
};
